import React from 'react';
import classNames from 'classnames';

const radiusValues = [
    '100m',
    '500m',
    '1km',
    '2km',
    '5km',
    '10km',
];

const RadiusSelector = ({radius, setRadius}) => (
    <div className="btn-group w-100" role="group">
        {radiusValues.map(value => (
            <button
                key={value}
                type="button"
                className={classNames({
                    'btn btn-gradient btn-xs': true,
                    'active': value === radius,
                })}
                onClick={e => {
                    e.currentTarget.blur();

                    setRadius(value);
                }}
            >
                {value}
            </button>
        ))}
    </div>
);

export default RadiusSelector;
